<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>School</h1>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="school.code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="school.desc"
            ></v-text-field>
          </v-col>
          <v-col>
            <selection :show-dense="false" :show-select="true"></selection>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <pagination :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
        <template slot="viewEducAttain" slot-scope="{ item }">
          <v-btn @click.stop="viewEduAttainment(item)" text outlined
            >View</v-btn
          >
        </template>
      </pagination>
      <v-dialog v-model="editDialog" width="700" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Edit</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Code"
                  :class="classPadding"
                  v-model="editSchool.code"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Description"
                  :class="classPadding"
                  v-model="editSchool.desc"
                ></v-text-field>
              </v-col>
            </v-row>
            <selection :show-dense="false" :show-select="true"></selection>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click.stop="editDialog = false"
              >Close</v-btn
            >
            <v-btn
              text
              color="success"
              @click.stop="update"
              :loading="isUpdating"
              v-if="userAccess.update >= 1"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="educAttainDialog" width="500" scrollable>
        <v-card>
          <v-card-title>
            <span class="headline">Education Attainment</span>
          </v-card-title>
          <v-card-text>
            <v-simple-table dense fixed-header>
              <tbody>
                <tr v-for="(item, key) in selectedEducAttainment" :key="key">
                  <td>{{ item.eduAttDesc }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import Pagination from "./Pagination";
import Selection from "../educ-attainment/Selection";
import EventBus from "../../../../../events/eventBus";
import _ from "lodash";
import userAccessMixin from "../../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/school";
const API_ENDPOINT_ATT = "/api/educAttainment";
export default {
  metaInfo: {
    title: "School",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    // List
    Pagination,
    Selection
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    isUpdating: false,
    school: {},
    componentKey: 0,
    editSchool: {},
    editDialog: false,
    selectedEducAttainment: [],
    educAttainDialog: false
  }),
  methods: {
    save() {
      this.isSaving = true;

      var eduAttCodes = this.selectedEducAttainment.map(function(item) {
        return item.eduAttCode;
      });
      var model = {
        school: this.school,
        eduAttCode: eduAttCodes
      };
      this.$axios
        .post(`${API_ENDPOINT}`, model)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      var rel = Object.assign({}, item);
      this.editSchool.code = rel.schoolCode;
      this.editSchool.desc = rel.schoolDesc;
      this.editDialog = true;

      this.getSubBySchoolCode(item.schoolCode);
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.schoolCode}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.school = {};
      this.forceRerender();
      this.editDialog = false;
      this.clearSelectedEducAttainment();
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;
      var eduAttCodes = this.selectedEducAttainment.map(function(item) {
        return item.eduAttCode;
      });
      var model = {
        school: this.editSchool,
        eduAttCode: eduAttCodes
      };
      this.$axios
        .put(`${API_ENDPOINT}`, model)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    clearSelectedEducAttainment() {
      EventBus.$emit("CLEAR_EDUC_ATT");
    },
    viewEduAttainment(item) {
      this.getSubBySchoolCode(item.schoolCode);
      this.educAttainDialog = true;
    },
    getSubBySchoolCode(schoolCode) {
      this.$axios
        .get(`${API_ENDPOINT}/sub/${schoolCode}`)
        .then(({ data }) => {
          this.selectedDuties = data;
          if (!_.isEmpty(data)) {
            var codes = _.map(data, "eduAttCode");
            this.getEducAttainment(codes);
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    getEducAttainment(codes) {
      this.$axios
        .post(`${API_ENDPOINT_ATT}/codes`, codes)
        .then(({ data }) => {
          EventBus.$emit("TOGGLE_SELECTED_EDUC_ATT", data);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    }
  },
  mounted() {
    EventBus.$on("SELECTED_EDUC_ATT", payload => {
      this.selectedEducAttainment = payload;
    });
  },
  watch: {
    editDialog(val) {
      if (!val) {
        this.clearSelectedEducAttainment();
      }
    },
    educAttainDialog(val) {
      if (!val) {
        this.clearSelectedEducAttainment();
      }
    }
  },
  created() {
    this.getUserAccessRights("School");
  }
};
</script>